import { Panel, SectionHeader, fmt } from "./DashboardPrimitives";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Index 0 = noDunning (excluded), 1–3 = M1, M2, M3
const DUNNING_COLORS = ["#22c55e", "#f59e0b", "#ef4444"];
const DUNNING_LEVELS = [1, 2, 3];

interface DunningPanelProps {
    counts: number[];   // full 5-element array from useDashboard
    amounts: number[];  // full 5-element array from useDashboard
}

export function DunningPanel({ counts, amounts }: DunningPanelProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const DUNNING_LABELS = [
        t("dashboard.friendly"),
        t("dashboard.demanding"),
        t("dashboard.final"),
    ];
    const displayCounts  = counts.slice(1, 4);
    const displayAmounts = amounts.slice(1, 4);

    return (
        <Panel>
            <SectionHeader title={t("dashboard.dunningStatus")} />
            <div className="stat-grid stat-grid--3col">
                {DUNNING_LABELS.map((label, i) => (
                    <div
                        key={i}
                        className="stat-grid__item"
                        onClick={() => navigate("/invoices", { state: { viewKey: "open", filters: { dunning: String(DUNNING_LEVELS[i]) } } })}
                    >
                        <div
                            className="stat-card__icon"
                            style={{ background: DUNNING_COLORS[i] + "18", color: DUNNING_COLORS[i] }}
                        >
                            <span style={{ fontSize: 13, fontWeight: 700 }}>
                                {`M${i + 1}`}
                            </span>
                        </div>
                        <div>
                            <div className="stat-card__value">{displayCounts[i]}</div>
                            <div className="stat-card__label">{label}</div>
                            <div className="stat-card__sub">{fmt(displayAmounts[i])}</div>
                        </div>
                    </div>
                ))}
            </div>
        </Panel>
    );
}
